import { config } from "./config"; // 加载配置
import AWS from "aws-sdk";
import { ondays } from "./TimeTable";

AWS.config.update(config.aws); // 更新 AWS 配置
const documentClient = new AWS.DynamoDB.DocumentClient();
let debug = true;
var currentUrl = window.location.href;
if (currentUrl.includes("master")) {
  debug = false;
}
// console.log("currentUrl", currentUrl);
// console.log("debug", debug);

let numberOfWeeks = config.numberOfWeeks;
let tableName = "clinic_appointment_system";
let patientTableName = "clinic_patient_db";
if (debug) {
  tableName = "clinic_appointment_system_demo";
  patientTableName = "clinic_patient_db_demo";
}
const today = config.getUTC8Time();

export const insertData = async (data) => {
  data.createTime = await config.getTaipeiTimeString();
  data.lastModifyDate = await config.getTaipeiTimeString();
  const params = {
    TableName: tableName,
    Item: data,
  };

  try {
    await documentClient.put(params).promise();
    console.log("Insert succeeded:", data);
    let clonedData = JSON.parse(JSON.stringify(data));
    clonedData.debug = debug;
    clonedData.msg = "insertData";
    postAppRecord(clonedData);
    // await lineNotify(clonedData);
    return true;
  } catch (err) {
    console.error("Unable to insert item. Error:", err);
    return false;
  }
  // fetchData(setData);
};

export const insertDataToPatientDB = async (data) => {
  const params = {
    TableName: patientTableName,
    Item: data,
  };

  try {
    await documentClient.put(params).promise();
    console.log("Insert succeeded:", data);
    let clonedData = JSON.parse(JSON.stringify(data));
    clonedData.debug = debug;
    clonedData.msg = "insertDataToPatientDB";
    postAppRecord(clonedData);
    // await lineNotify(clonedData);
    return true;
  } catch (err) {
    console.error("Unable to insert item. Error:", err);
    return false;
  }
  // fetchData(setData);
};

const updateOndaysData = (sortData, onDaysData) => {
  // check if time is full
  Object.keys(sortData).forEach((date) => {
    Object.keys(sortData[date]).forEach((time) => {
      // if (time === "onste") {
      //   //skip the loop
      //   return;
      // }
      let first = 0;
      let all = 0;
      sortData[date][time].forEach((people) => {
        const hour = people.hour;
        all = all + 1;
        if (people.first) {
          // console.log("date:", date, "hour:", hour, "time:", time);
          onDaysData[date].hours[hour][time].people.first.push(people);

          first++;
        } else {
          onDaysData[date].hours[hour][time].people.follow.push(people);
        }
        if (first >= onDaysData[date].hours[hour][time].first) {
          onDaysData[date].hours[hour][time].isFullFirst = true;
        }
        if (all >= onDaysData[date].hours[hour][time].all) {
          onDaysData[date].hours[hour][time].isFullAll = true;
          onDaysData[date].hours[hour][time].isFullFirst = true;
        }
      });
    });
  });
  // check if hour is full
  Object.keys(onDaysData).forEach((date) => {
    Object.keys(onDaysData[date].hours).forEach((hour) => {
      let isFullAll = true;
      let isFullFirst = true;
      Object.keys(onDaysData[date].hours[hour]).forEach((time) => {
        //! 需要排除掉不是時間的 key
        if (!/^[0-9]/.test(time[0])) {
          return;
        }
        // if (time === "onste"){
        //   return;
        // }

        if (onDaysData?.[date]?.hours?.[hour]?.[time]?.isFullAll === false) {
          isFullAll = false;
        }
        if (onDaysData?.[date]?.hours?.[hour]?.[time]?.isFullFirst === false) {
          isFullFirst = false;
        }
      });
      onDaysData[date].hours[hour].isFullAll = isFullAll;
      onDaysData[date].hours[hour].isFullFirst = isFullFirst;
    });
  });
  return onDaysData;
};

export const deleteData = async (
  dataToDelete,
  setData,
  setOrginalData,
  clinic_name
) => {
  const params = {
    TableName: tableName,
    Key: {
      clinic: dataToDelete.clinic,
      date: dataToDelete.date,
    },
  };

  try {
    await documentClient.delete(params).promise();
    console.log("Delete succeeded:", dataToDelete);
    let clonedData = JSON.parse(JSON.stringify(dataToDelete));
    clonedData.debug = debug;
    clonedData.msg = "deleteData";
    clonedData.lastModifyDate = await config.getTaipeiTimeString();
    postAppRecord(clonedData);
    // await lineNotify(clonedData);
    // 添加延遲以確保資料已更新
    // window.confirm("預約已經取消");
    return true;
  } catch (err) {
    console.error("Unable to delete items. Error:", err);
    return false;
  }
};

/**
 * Fetches data for a given clinic.
 *
 * @param {string} clinic_name - The name of the clinic to fetch data for.
 * @returns {Promise<void>} A promise that resolves when the data is fetched.
 */
export const fetchData = async (clinic_name) => {
  // const today = getUTC8Time();
  // console.log("todayymdhms:", today);
  console.log(
    "todayymdhms:",
    `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(today.getDate()).padStart(2, "0")} ${String(
      today.getHours()
    ).padStart(2, "0")}:${String(today.getMinutes()).padStart(2, "0")}:${String(
      today.getSeconds()
    ).padStart(2, "0")}`
  );
  const todayymd = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  let onDaysData = Object.assign({}, ondays(today, numberOfWeeks, clinic_name));
  const dataToSort = (inputData) => {
    const outputData = {};
    inputData.forEach((item) => {
      const [dateSlot, timeSlot, index] = item.date.split("_");
      if (!outputData[dateSlot]) {
        outputData[dateSlot] = {};
      }
      if (!outputData[dateSlot][timeSlot]) {
        outputData[dateSlot][timeSlot] = [];
      }
      // 将完整的数据对象放入相应的位置
      const { date: itemDate, ...rest } = item; // 这里重命名date为itemDate
      // console.log("outputData:", outputData);
      outputData[dateSlot][timeSlot].push(rest);
    });

    return outputData;
  };
  try {
    let originalData_temp;
    if (clinic_name === "all") {
      const params1 = {
        TableName: tableName,
        KeyConditionExpression: "#pk = :pk1 and #sk >= :sk",
        ExpressionAttributeNames: {
          "#pk": "clinic",
          "#sk": "date",
        },
        ExpressionAttributeValues: {
          ":pk1": "hansheng",
          ":sk": todayymd,
        },
      };
      const params2 = {
        TableName: tableName,
        KeyConditionExpression: "#pk = :pk2 and #sk >= :sk",
        ExpressionAttributeNames: {
          "#pk": "clinic",
          "#sk": "date",
        },
        ExpressionAttributeValues: {
          ":pk2": "yoyo",
          ":sk": todayymd,
        },
      };
      const data1 = await documentClient.query(params1).promise();
      const data2 = await documentClient.query(params2).promise();
      originalData_temp = [...data1.Items, ...data2.Items];
    } else {
      const params0 = {
        TableName: tableName,
        KeyConditionExpression: "#pk = :pk0 and #sk >= :sk",
        ExpressionAttributeNames: {
          "#pk": "clinic",
          "#sk": "date",
        },
        ExpressionAttributeValues: {
          ":pk0": clinic_name,
          ":sk": todayymd,
        },
      };
      const data0 = await documentClient.query(params0).promise();
      originalData_temp = [...data0.Items];
    }

    // setOrginalData(data.Items); // set the original data
    const sortData = dataToSort(originalData_temp);
    let data_temp = updateOndaysData(sortData, onDaysData); // check if time and hour is full
    console.log("Query succeeded:");
    // return data.Items and onDaysData;
    return { originalData_temp, data_temp };
  } catch (err) {
    // setData();
    console.error("Unable to query items. Error:", err);
    let originalData_temp = false;
    let data_temp = false;
    return { originalData_temp, data_temp };
  }
  // return alert("Data fetched");
};

/**
 * Fetches data for a given patient.
 *
 * @param {string} ID - The ID of the patient to fetch data for.
 * @returns {Promise<void>} A promise that resolves when the data is fetched.
 */
export const fetchData_from_patient = async (ID) => {
  // callCountRef.current += 1;
  // console.log("callCountRef.current", callCountRef.current);

  const params = {
    TableName: patientTableName,
    KeyConditionExpression: "#pk = :pk",
    ExpressionAttributeNames: {
      "#pk": "ID",
    },
    ExpressionAttributeValues: {
      ":pk": ID,
    },
  };
  try {
    const originalData_clinic_patient_dbtemp = await documentClient
      .query(params)
      .promise();

    console.log(
      "Query succeeded for clinic_patient_db:",
      originalData_clinic_patient_dbtemp
    );
    return originalData_clinic_patient_dbtemp.Items;
  } catch (err) {
    // setData();
    console.error("Unable to query items from clinic_patient_db. Error:", err);
    return false;
  }
};

export const postAppRecord = async (data) => {
  const url =
    "https://8nkgc9n0a6.execute-api.ap-northeast-1.amazonaws.com/prod/app_record";
  // const data = {
  //   "clinic data": {
  //     test: 123,
  //   },
  // };

  try {
    // 使用 no-cors 模式，但這會限制您獲取響應內容
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
      mode: "no-cors", // 使用 no-cors 模式
    });

    // 注意：使用 no-cors 模式時，無法訪問響應內容
    console.log("成功發送資料到 app_record");
    return true; // 直接返回 true，因為無法檢查響應
  } catch (error) {
    console.error("發送資料到 app_record 時發生錯誤:", error);
    // 即使發生錯誤也繼續執行
    return true;
  }
};

export const lineNotify = async (data) => {
  // 定义请求的 URL 和查询参数
  const url =
    "https://r53qufdexa2v4cahnkn6plbsta0vkwjy.lambda-url.ap-northeast-1.on.aws/?dennis=123";

  // 定义请求体数据

  // 使用 fetch 发送 POST 请求
  fetch(url, {
    method: "POST", // 使用 POST 方法
    mode: "no-cors", // 使用 no-cors 模式
    headers: {
      "Content-Type": "application/json", // 设置请求头，指定内容类型为 JSON
    },
    body: JSON.stringify(data), // 将 JavaScript 对象转换为 JSON 字符串
  })
    .then((response) => {
      // 使用 no-cors 模式时，无法访问响应的内容
      console.log("Request sent successfully");
    })
    .catch((error) => {
      console.error("Error:", error); // 打印错误信息
    });
}; // 确保函数闭合

export const fetchAllData = async (tableName) => {
  const threeMonthsAgo = new Date(today);
  threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 2); // 設置為三個月前的資料
  const startDate =
    threeMonthsAgo.toISOString().split("T")[0].slice(0, 8) + "01";
  console.log("startDate", startDate);
  const params = {
    TableName: tableName,
    ProjectionExpression:
      "ID, createTime, #first, gender, clinic, birthday, #data, currentDate, lastModifyDate, referral",
    ExpressionAttributeNames: {
      "#first": "first",
      "#data": "data",
    },
    FilterExpression: "ID <> :leaveId AND lastModifyDate > :startDate",
    ExpressionAttributeValues: {
      ":leaveId": "leave",
      ":startDate": startDate,
    },
  };

  try {
    const allData = await documentClient.scan(params).promise();
    console.log(
      `Successfully retrieved all data from ${tableName} table:`,
      allData
    );
    // 過濾掉每個病人資料中早於startDate的預約記錄
    allData.Items = allData.Items.map((element) => {
      if (element.data) {
        const filteredData = {};
        let hasOldData = false;
        let firstNewDate = null;

        Object.entries(element.data).forEach(([date, value]) => {
          if (date >= startDate) {
            filteredData[date] = value;
            if (!firstNewDate || date < firstNewDate) {
              firstNewDate = date;
            }
          } else {
            hasOldData = true;
          }
        });

        if (!hasOldData && firstNewDate) {
          filteredData[firstNewDate] = {
            ...filteredData[firstNewDate],
            first: true,
            notFirst: false,
          };
        } else {
          filteredData[firstNewDate] = {
            ...filteredData[firstNewDate],
            first: false,
            notFirst: true,
          };
        }
        element.data = filteredData;
      }
      return element;
    });
    return allData.Items;
  } catch (err) {
    console.error(
      `Unable to retrieve all data from ${tableName} table. Error:`,
      err
    );
    return false;
  }
};
